"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgMusicNote02 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.726 3.245c-.352-.176-.674-.337-.948-.444-.282-.11-.654-.223-1.07-.162a2 2 0 0 0-1.347.833c-.241.345-.307.728-.334 1.03C11 4.793 11 5.154 11 5.547v8.987a4 4 0 1 0 2 3.468V5.59c0-.448.001-.715.018-.906l.003-.03.03.01c.177.07.416.189.817.39l3.685 1.841a1 1 0 1 0 .894-1.788l-3.721-1.861Z", fill: "currentColor" }) }))); };
exports.default = SvgMusicNote02;
